class ItsSearch extends HTMLElement {
    constructor() {
        super();

        this.button = this.querySelector('#its-filters-open');
        this.buttonSubmit = this.querySelector('#its-filter-apply input');
        this.buttonClose = this.querySelector('#its-filter .its-filters-title img');
        this.filters = this.querySelector('#its-filter');
        this.filtersSelected = this.querySelector('#its-filter  .its-filters-selected');
        this.form = this.querySelector('#its-filter form');
        this.overlay = this.querySelector('#its-filter-overlay');

        // Add listener on all accordion
        const accordions = this.querySelectorAll('#its-filter form .its-filters-wrapper .its-filters-header');
        for (const accordion of accordions) {
            accordion.addEventListener('click', (e) => {
                const attr = accordion.getAttribute('data-filter-name');
                const img = document.querySelector(`#its-filter form .its-filters-wrapper .its-filters-header[data-filter-name="${attr}"] img`)
                const isOpen = e.currentTarget.nextElementSibling.classList.contains('preview') || e.currentTarget.nextElementSibling.classList.contains('full');

                if (isOpen) {
                    e.currentTarget.nextElementSibling.classList.remove('preview');
                    e.currentTarget.nextElementSibling.classList.remove('full');
                    img.classList.remove('flip');
                    e.currentTarget.nextElementSibling.nextElementSibling.style.display = 'none';
                } else {
                    e.currentTarget.nextElementSibling.classList.add('preview');
                    img.classList.add('flip');
                    e.currentTarget.nextElementSibling.nextElementSibling.style.display = 'block';
                }
            });
        }

        // Add listener on all accordion show more
        const accordionsMore = this.querySelectorAll('#its-filter form .its-filters-wrapper .its-more');
        for (const accordion of accordionsMore) {
            accordion.addEventListener('click', (e) => {
                e.currentTarget.previousElementSibling.classList.add('full');
                e.currentTarget.style.display = 'none';
            });
        }

        this.form.addEventListener('change', (e) => {
            this.getResults();
            this.selectFilter();
        });

        this.button.addEventListener('click', (e) => {
            e.preventDefault();
            this.open();
        });

        this.buttonClose.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
        });

        this.overlay.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
        });
    }

    getResults() {
        const queryString = new URLSearchParams(new FormData(this.form)).toString();
        fetch(`${window.location.pathname}?${queryString}`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const res = text.match(/<span>\d+\sproduit/);
                const count = res[0].replace('<span>', '').replace('produit', '');
                this.buttonSubmit.value = `Voir les ${count.trim()} produit(s)`;
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    selectFilter() {
        const filters = new FormData(this.form);
        this.filtersSelected.innerHTML = '';
        const count = {};

        for (const form of filters) {
            if (['sort_by', 'q'].indexOf(form[0]) !== -1 || form[1] === '') continue;

            // Count items
            if (count[form[0]] === undefined) count[form[0]] = 0;
            count[form[0]]++;

            // Get header el
            const ref = document.querySelector(`#its-filter .its-filters-header[data-filter-name="${form[0]}"] span`);

            // Prepare the li
            const label = ref.innerHTML.trim().split('\n')[0]
            const li = document.createElement("li");
            const queryString = new URLSearchParams(new FormData(this.form));
            queryString.delete(form[0], form[1]);
            li.innerHTML = `<a href="${window.location.pathname}?${queryString.toString()}">${label}: ${form[1]}<img src="/cdn/shop/t/4/assets/its-close.svg?v=152331599915588569911713776742" alt="image"></a>`;

            this.filtersSelected.appendChild(li);
        }

        // Update counter
        for (const [key, value] of Object.entries(count)) {
            const ref = document.querySelector(`#its-filter .its-filters-header[data-filter-name="${key}"] span`);
            const label = ref.innerHTML.trim().split('(')[0];

            ref.innerHTML = `${label}\n(${value})`;
        }
    }

    open() {
        document.querySelector(".header-content").style['z-index'] = 100;
        this.filters.style.display = 'block';
        this.overlay.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }

    close() {
        document.querySelector(".header-content").style['z-index'] = 201;
        this.filters.style.display = 'none';
        this.overlay.style.display = 'none';
        document.body.style.overflow = 'auto';
    }
}

customElements.define('its-search', ItsSearch);

document.addEventListener("DOMContentLoaded", function() {
    const minRange = document.querySelector('.rangeslider .min');
    const maxRange = document.querySelector('.rangeslider .max');
    const minValueInput = document.querySelector('.dualslider-range-1');
    const maxValueInput = document.querySelector('.dualslider-range-2');

    // save values choose by user
    function saveRangeValues() {
        sessionStorage.setItem('minRangeValue', minRange.value);
        sessionStorage.setItem('maxRangeValue', maxRange.value);
    }

    // Get the slider values
    function loadRangeValues() {
        const savedMinValue = sessionStorage.getItem('minRangeValue');
        const savedMaxValue = sessionStorage.getItem('maxRangeValue');
        if (savedMinValue && savedMaxValue) {
            minRange.value = savedMinValue;
            maxRange.value = savedMaxValue;
            updateInputValues();
        }
    }

    updateInputValues();

    function updateInputValues() {
        minValueInput.value = minRange.value;
        maxValueInput.value = maxRange.value;
    }

    // Update min and max values for the slider
    function updateRangeLimits() {
        const minVal = parseInt(minRange.value, 10);
        const maxVal = parseInt(maxRange.value, 10);

        // Lock minimum slider if necessary
        if (minVal >= maxVal) {
            minRange.value = maxVal - 1;
        }

        // Lock maximum slider if necessary
        if (maxVal <= minVal) {
            maxRange.value = minVal + 1;
        }
    }

    minRange.addEventListener('input', function() {
        updateInputValues();
        saveRangeValues();

        // Make sure minRange does not fall below maxRange
        if (parseInt(minRange.value, 10) >= parseInt(maxRange.value, 10)) {
            minRange.value = parseInt(maxRange.value, 10) - 1;
        }

        updateInputValues();
        saveRangeValues();

    });

    maxRange.addEventListener('input', function() {
        updateInputValues();
        saveRangeValues();

        // Make sure maxRange does not fall below minRange
        if (parseInt(maxRange.value, 10) <= parseInt(minRange.value, 10)) {
            maxRange.value = parseInt(minRange.value, 10) + 1;
        }

        updateInputValues();
        saveRangeValues();
    });

    updateRangeLimits();
    loadRangeValues();
});
